// extracted by mini-css-extract-plugin
module.exports = {"root":"intro_root__1M7U9","outer":"intro_outer__2XILt","inner":"intro_inner__1HM15","heading":"intro_heading__18oCh","description":"intro_description__2MGAY"};